import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import Colors from '../styles/colors';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faMicrophone from '@fortawesome/fontawesome-free-solid/faMicrophone';
import faStop from '@fortawesome/fontawesome-free-solid/faStop';
import faCircle from '@fortawesome/fontawesome-free-solid/faCircle';
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
import faPause from '@fortawesome/fontawesome-free-solid/faPause';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FloatingActionButton from 'material-ui/FloatingActionButton';

import AudiojsRecordPlayer from './audiojs_record_player';

class Recordinguploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordingUrl: '',
      isRecording: false,
      isRecorded: false,
      isPlaying: false,
      isUploading: false,
      isUploaded: false,
      isDiscarding: false,
      isDiscarded: false,
      recordingStartTime: 0,
      currentRecordingDuration: 0,
      playingStartTime: 0,
      currentPlayingDuration: 0,
      recordingBlob: {},
    };

    this.player = null;
    this.recorder = null;
    this.mediaObject = null;

    this.setAudioMediaObject = this.setAudioMediaObject.bind(this);
    this.startRecording = this.startRecording.bind(this);
    this.stopRecording = this.stopRecording.bind(this);
    this.handleMicrophoneRecording = this.handleMicrophoneRecording.bind(this);
    this.playRecording = this.playRecording.bind(this);
    this.pausePlayer = this.pausePlayer.bind(this);
    this.saveRecording = this.saveRecording.bind(this);
    this.discardRecording = this.discardRecording.bind(this);
  }

  startRecording() {
    this.recorder = this.mediaObject.record();
    this.recorder.getDevice(); // triggers 'deviceReady'

    let recordingInterval = setInterval(() => {
      const { recordingStartTime } = this.state;
      if (!this.state.isRecording) {
        return clearInterval(recordingInterval);
      }

      this.setState({
        currentRecordingDuration: moment().diff(recordingStartTime), //recording duration in millliseconds
      });
    }, 1000);
  }

  stopRecording() {
    this.recorder.stop(); // triggers 'finishRecord'
  }

  playRecording() {
    this.wavesurfer.surfer.play();

    if (this.state.isRecorded) {
      this.setState({ isPlaying: true, playingStartTime: moment() });
    }

    let playingInterval = setInterval(() => {
      const { playingStartTime } = this.state;
      if (!this.state.isPlaying) {
        clearInterval(playingInterval);
      }

      this.setState({
        currentPlayingDuration: moment().diff(playingStartTime), //recording duration in millliseconds
      });
    }, 1000);
  }

  pausePlayer() {
    this.wavesurfer.surfer.pause();
    this.setState({ isPlaying: false, currentPlayingDuration: 0 });
    this.player.currentTime(0);
  }

  saveRecording() {
    // console.log('start converting to mp3');
    this.setState({
      currentPlayingDuration: 0,
      isPlaying: false,
      isUploading: true
    }, () => {
      this.player.pause();
      this.player.currentTime(0);

      // upload file to aws s3
      this.uploadRecording(this.state.recordingBlob, 'audio').then((recordingUrl) => {
        this.setState({
          recordingUrl,
          isUploading: false,
          isUploaded: true
        }, () => {
          this.props.onuploadcomplete(recordingUrl);
          setTimeout(() => {
            this.setState({
              isUploaded: false
            });
          }, 3000);
        });
      }).catch(this.props.onuploaderror);
    });
  }

  discardRecording() {
    // delete server if already saved
    if (!isEmpty(this.state.recordingUrl)) {
      this.setState({
        isDiscarding: true,
      }, () => {
        this.deleteRecording().then(() => {
          this.props.onremovedrecording();
          this.setState({
            recordingUrl: '',
            isDiscarding: false,
            isDiscarded: true
          }, () => {
            setTimeout(() => {
              this.setState({
                isDiscarded: false
              });
            }, 3000);
          });
        });
      });
    }

    this.setState({
      isRecorded: false,
      recordingBlob: {},
      audioDuration: 0,
      currentPlayingDuration: 0,
      currentRecordingDuration: 0,
      playingStartTime: null,
      recordingStartTime: null,
      isPlaying: false,
    }, () => {
      this.player.pause();
      this.player.currentTime(0);
      this.wavesurfer.surfer.empty();
    });
  }

  getFileFromBlob(blob) {
    return new window.File([blob], this.props.filename);
  }

  uploadRecording(blob, type) {
    return new Promise((resolve, reject) => {
      const { server, metadata, filename } = this.props;

      // append to form data
      let data = new FormData();
      const file = this.getFileFromBlob(blob);
      data.append('file', file, filename);
      data.append('recording', true);

      // append metadata if set
      if (!isEmpty(metadata)) {
        Object.keys(metadata).forEach(metakey => {
          const metavalue = metadata[metakey];
          data.append(metakey, metavalue);
        });
      }

      Axios.post(server, data)
        .then(res => {
          console.log(res);
          // replace 'http' with 'https'
          let recordingUrl = res.data[0].url;
          if (recordingUrl.slice(0, 5) !== 'https') {
            recordingUrl = recordingUrl.replace(/http/i, 'https');
          }

          resolve(recordingUrl);
        })
        .catch(err => {
          reject()
        });
    });
  }

  deleteRecording() {
    return new Promise((resolve, reject) => {
      // if do not remove from server is set
      // return a resolved state
      if (!this.props.serverRemove) {
        return resolve();
      }

      Axios.delete(this.props.server, {
        params: {
          url: this.state.recordingUrl,
        },
      })
        .then(res => {
          console.log(res);
          resolve();
        })
        .catch(err => {
          console.log('ERROR remove recording', err);
          reject();
        });
    });
  }

  handleMicrophoneRecording() {
    this.state.isRecording ? this.stopRecording() : this.startRecording();
  }

  setAudioMediaObject(mediaObject) {
    this.mediaObject = mediaObject;
    this.mediaObject.on('deviceReady', () => {
      this.recorder.start(); // start recording
    });
    this.mediaObject.on('deviceError', () => {
      // error handling
      console.log('device error:', this.mediaObject.deviceErrorCode);
    });
    this.mediaObject.on('error', error => console.log('error:', error));
    // user clicked the record button and started recording
    this.mediaObject.on('startRecord', () => {
      this.setState({ isRecording: true, recordingStartTime: moment() });
    });
    this.mediaObject.on('ended', () => this.setState({ isPlaying: false }));
    // user completed recording and stream is available
    this.mediaObject.on('finishRecord', () => {
      // the blob object contains the recorded data that
      // can be downloaded by the user, stored on server etc.
      // console.log('finished recording: ', mediaObject.recordedData);
      const { recordedData } = this.mediaObject;
      this.recorder.stopDevice();
      this.player.src({
        type: 'video/mp4',
        src: window.URL.createObjectURL(recordedData),
      });

      this.setState(
        {
          recordingBlob: recordedData, // blobObject,
          isRecorded: true,
          isRecording: false,
        },
        () => {
          const file = this.getFileFromBlob(recordedData);
          this.props.onprocessrecording(file);
        }
      );
    });

    this.player = this.mediaObject.player();
    this.wavesurfer = this.mediaObject.wavesurfer();
  }

  withIcon(message, icon = '') {
    if (isEmpty(icon)) {
      return null;
    }

    const ext = (icon === 'loader') ? 'gif' : 'png';
    return (
      <React.Fragment>
        {!isEmpty(icon) && <img src={`../images/status_${icon}.${ext}`} alt={icon} style={{marginRight: 5}}/>}
        {message}
      </React.Fragment>
    );
  }

  renderStatusSection() {
    let {
      isRecording,
      isRecorded,
      recordingUrl,
      isUploading,
      isUploaded,
      isDiscarding,
      isDiscarded,
    } = this.state;

    let content = null;

    if (isRecording) {
      content = 'Recording your beautiful voice...';
    } else if (isDiscarding) {
      content = this.withIcon('Discarding recorded audio...', 'loader');
    } else if (isDiscarded) {
      content = this.withIcon('Recorded audio has been succesfully discarded', 'success');
    } else if (isUploading) {
      content = this.withIcon('Uploading recorded audio...', 'loader');
    } else if (isUploaded) {
      content = this.withIcon('Recorded audio has been succesfully uploaded', 'success');
    } else if (isRecorded) {
      content = (
        <React.Fragment>
          {!isEmpty(recordingUrl) && (
            <div style={{ ...styles.saveText, cursor: 'default', color: '#399467' }}>
              Saved
            </div>
          )}
          {isEmpty(recordingUrl) && (
            <div style={styles.saveText} onClick={this.saveRecording}>
              Save
            </div>
          )}
          <div
            style={styles.discardText}
            onClick={this.discardRecording}
          >
            Discard
          </div>
        </React.Fragment>
      );
    }

    return (
      <div style={styles.statusWrapper}>
        {content}
      </div>
    );
  }

  render() {
    let {
      isRecording,
      isPlaying,
      currentRecordingDuration,
      currentPlayingDuration,
      isRecorded,
    } = this.state;

    // if recording, render it
    // TODO: fixed media queries once styled components is available
    const recorderBtns = () => {
      let btnProps = {
        handler: this.handleMicrophoneRecording,
        icon: isRecording ? faStop : faMicrophone,
      };

      // if already recorder, show a different button
      if (isRecorded) {
        btnProps = {
          handler: isPlaying ? this.pausePlayer : this.playRecording,
          icon: isPlaying ? faPause : faPlay,
        };
      }

      return (
        <FloatingActionButton backgroundColor="#eb4f40" onClick={btnProps.handler}>
          <FontAwesomeIcon icon={btnProps.icon} color="white" inverse="true" size="2x" />
        </FloatingActionButton>
      );
    };

    return (
      <div style={styles.plainWhiteWrapper}>
        <div style={styles.miniHeaderText}>
          Record Audio<span style={styles.requiredTxt}>*</span>&nbsp;
          <span style={styles.miniSubheaderText}>Make sure a mic is available</span>
        </div>
        <div style={styles.recorderWrapper}>
          <div style={styles.recorderDivision}>
            <MuiThemeProvider>{recorderBtns()}</MuiThemeProvider>
          </div>
          <div style={{ ...styles.recorderDivision, position: 'relative' }}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <AudiojsRecordPlayer
                options={{
                  width: 250,
                  height: 35,
                }}
                style={{
                  borderRadius: 20,
                }}
                setMediaObject={this.setAudioMediaObject}
              />
              <div style={styles.recorderSeekTime}>
                {(!isPlaying &&
                  currentRecordingDuration &&
                  moment.utc(currentRecordingDuration).format('HH:mm:ss')) ||
                  moment.utc(currentPlayingDuration).format('HH:mm:ss') ||
                  moment.utc(0).format('HH:mm:ss')}
              </div>
            </div>
            {this.renderStatusSection()}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  plainWhiteWrapper: {
    backgroundColor: Colors.mainWhite,
    padding: '10px 20px',
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
  },
  miniHeaderText: {
    fontSize: 18,
    color: Colors.black,
    fontWeight: 800,
    paddingTop: 10,
    paddingBottom: 10,
  },
  miniSubheaderText: {
    fontWeight: 'normal',
    fontSize: '1.4rem',
    verticalAlign: 'bottom',
  },
  requiredTxt: {
    color: Colors.red,
  },
  recorderDivision: {
    padding: '0px 10px',
  },
  recorderWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 20px 30px',
  },
  statusWrapper: {
    position: 'absolute',
    padding: 5,
  },
  saveText: {
    color: Colors.link,
    fontWeight: 'bold',
    fontSize: '1.7rem',
    display: 'inline-block',
    cursor: 'pointer',
    marginRight: 10,
  },
  discardText: {
    fontSize: '1.7rem',
    display: 'inline-block',
    cursor: 'pointer',
  },
  recorderSeekTime: {
    fontSize: '1.6rem',
    fontWeight: 600,
    padding: '0px 20px'
  },
  statusProcess: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
  },
};

Recordinguploader.propTypes = {
  server: PropTypes.string,
  serverRemove: PropTypes.bool,
  filename: PropTypes.string,
  metadata: PropTypes.object,
  onuploadcomplete: PropTypes.func,
  onuploaderror: PropTypes.func,
  onprocessrecording: PropTypes.func,
  onremovedrecording: PropTypes.func,
};

Recordinguploader.defaultProps = {
  server: '',
  serverRemove: true,
  filename: 'audiorecording.mp3',
  metadata: {},
  onuploadcomplete: () => {},
  onuploaderror: () => {},
  onprocessrecording: () => {},
  onremovedrecording: () => {},
};

export default Recordinguploader;
